// Story 10.3 — `GET /bots/:id/conversations/:sessionId`.
import { useQuery } from '@tanstack/react-query';
import { conversationsApi } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

export function useConversation(botId: number, sessionId: number | null) {
  return useQuery({
    queryKey: queryKeys.conversationDetail(botId, sessionId ?? -1),
    queryFn: () => conversationsApi.get(botId, sessionId as number),
    enabled: Number.isFinite(botId) && sessionId !== null && sessionId > 0,
    staleTime: 60_000,
  });
}
